module.exports = __webpack_public_path__ + "img/logo.fdb50a2f.png";